// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__50pQC","colMin":"styles_colMin__cAQcs"};